export default {
  'paymentHistory.time.last_three_months': '過去3か月',
  'paymentHistory.time.last_six_months': '過去6か月',
  'paymentHistory.time.last_one_year': '過去1年間',
  'paymentHistory.status.completed': '完了',
  'paymentHistory.status.canceled': 'キャンセル済み',
  'paymentHistory.status.partial_canceled': '一部キャンセル',
  'paymentHistory.title': '取引履歴',
  'paymentHistory.detail': '取引明細',
  'paymentHistory.update_time': '時間',
  'paymentHistory.total_amount': '総額',
  'paymentHistory.store': '店舗',
  'paymentHistory.status': 'ステータス',
  'paymentHistory.level_progress_text.amounts':
    'あと <span style="font-weight: 600;color: #05B34D;">{amount}</span> 円のご利用で',
  'paymentHistory.level_progress_text.counts':
    '<span style="font-weight: 600;color: #05B34D;">{count}</span> 円以上のご利用をあと <span style="font-weight: 600;color: #05B34D;">{amount}</span> 回で',
  'paymentHistory.level_progress_text.or': 'または',
  'paymentHistory.period_amount': '有効期間内の累計消費',
  'paymentHistory.member_total_amount': '累計消費',
  'paymentHistory.dollar': '円',
  'paymentHistory.zero_dollar': '0 円',
  'paymentHistory.trade_time': '取引時間',
  'paymentHistory.empty': 'データなし',
  'paymentHistory.name': '物品',
  'paymentHistory.quantity': '数量',
  'paymentHistory.price': '単価',
  'paymentHistory.amount': '支払金額',
  'paymentHistory.cancel_date': 'キャンセル日時',
} as Record<string, string>;
